<mat-card appearance="outlined">
  <mat-card-title>{{"MAIN_APP_ADRESSES.ortAuswählen" | translate}}</mat-card-title>
<mat-card-content>
  <table
    mat-table
    [dataSource]="dataSourceCities"
    class="mat-elevation-z8"
    style="width: 100%"
  >
    <!-- Ort Column -->
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MAIN_APP_ADRESSES.ort" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.town }}</td>
    </ng-container>

    <!-- Kanton Column -->
    <ng-container matColumnDef="canton">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MAIN_APP_ADRESSES.kanton" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.canton }}</td>
    </ng-container>

    <!-- Land Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>
        {{ "MAIN_APP_ADRESSES.land" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.country }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedCityColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedCityColumns"
      (click)="highlight(row)"
      [ngClass]="{ highlight: selectedCity == row }"
    ></tr>
  </table>
</mat-card-content>
</mat-card>


